var _defs, _rect, _circle, _path, _g, _path2, _g2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeritocracy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2471",
    "data-name": "Rettangolo 2471",
    width: 12.802,
    height: 17.713,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2465",
    "data-name": "Rettangolo 2465",
    width: 3.356,
    height: 6.824,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2468",
    "data-name": "Rettangolo 2468",
    width: 7.788,
    height: 2.679,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2469",
    "data-name": "Rettangolo 2469",
    width: 11.191,
    height: 11.191,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5591",
    "data-name": "Raggruppa 5591",
    transform: "translate(-1491 -483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5574",
    "data-name": "Raggruppa 5574",
    transform: "translate(1491 483)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2497",
    "data-name": "Rettangolo 2497",
    width: 24,
    height: 24,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_553",
    "data-name": "Ellisse 553",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(2 2)",
    fill: "#f5f1ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5534",
    "data-name": "Raggruppa 5534",
    transform: "translate(5.599 3.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5504",
    "data-name": "Raggruppa 5504",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11922",
    "data-name": "Tracciato 11922",
    d: "M0,282.449l2.539-.587,1.133,2.346,3.217-6.717-3.672-1.759Z",
    transform: "translate(0 -266.496)",
    fill: "#e5373a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5492",
    "data-name": "Raggruppa 5492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5491",
    "data-name": "Raggruppa 5491",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5490",
    "data-name": "Raggruppa 5490",
    transform: "translate(3.533 10.888)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5489",
    "data-name": "Raggruppa 5489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5488",
    "data-name": "Raggruppa 5488",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11923",
    "data-name": "Tracciato 11923",
    d: "M108.59,325.018l-3.131,6.537.139.288,3.217-6.717Z",
    transform: "translate(-105.459 -325.018)",
    fill: "#e6e7e8"
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11924",
    "data-name": "Tracciato 11924",
    d: "M176.506,277.492l3.217,6.717,1.133-2.346,2.539.587-3.217-6.717Z",
    transform: "translate(-170.593 -266.496)",
    fill: "#e5373a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5503",
    "data-name": "Raggruppa 5503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5502",
    "data-name": "Raggruppa 5502",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5495",
    "data-name": "Raggruppa 5495",
    transform: "translate(5.913 10.888)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5494",
    "data-name": "Raggruppa 5494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5493",
    "data-name": "Raggruppa 5493",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11925",
    "data-name": "Tracciato 11925",
    d: "M176.731,325.018l3.131,6.537-.139.288-3.217-6.717Z",
    transform: "translate(-176.506 -325.018)",
    fill: "#e6e7e8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5498",
    "data-name": "Raggruppa 5498",
    transform: "translate(2.507 9.65)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5497",
    "data-name": "Raggruppa 5497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5496",
    "data-name": "Raggruppa 5496",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11926",
    "data-name": "Tracciato 11926",
    d: "M82.115,288.04a4.759,4.759,0,0,1-6.763,0l-.513,1.07a2.019,2.019,0,0,1,.863.109,1.335,1.335,0,0,1,.351.586.843.843,0,0,0,.357.484c.345.143.883-.329,1.257-.255.316.062.6.555.915.684l.15-.313.15.313c.32-.129.6-.622.915-.684.375-.074.913.4,1.257.255s.4-.862.708-1.07a2.019,2.019,0,0,1,.863-.109Z",
    transform: "translate(-74.84 -288.04)",
    fill: "#d1d3d4"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11927",
    "data-name": "Tracciato 11927",
    d: "M54.877,40.025a4.89,4.89,0,1,1-4.89-4.89,4.89,4.89,0,0,1,4.89,4.89",
    transform: "translate(-43.585 -33.958)",
    fill: "#f9d511"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11928",
    "data-name": "Tracciato 11928",
    d: "M21.376,7.132c.072-.363.716-.68.716-1.065s-.644-.7-.716-1.065.4-.913.255-1.257a.836.836,0,0,0-.484-.357,1.338,1.338,0,0,1-.586-.351c-.21-.314.02-.993-.247-1.26a.715.715,0,0,0-.49-.142,1.617,1.617,0,0,1-.769-.1.8.8,0,0,1-.246-.342C18.678.9,18.58.557,18.347.46,18,.317,17.464.79,17.09.716S16.409,0,16.025,0s-.7.644-1.065.716a.451.451,0,0,1-.128.006C14.47.694,14.009.333,13.7.46c-.351.146-.4.862-.708,1.07s-.993-.02-1.259.246-.036.945-.247,1.26-.925.357-1.07.708c-.127.308.234.768.261,1.13A.453.453,0,0,1,10.673,5c-.072.364-.716.68-.716,1.065s.644.7.716,1.065-.4.913-.255,1.258c.1.233.445.332.729.462a.814.814,0,0,1,.341.246,1.616,1.616,0,0,1,.1.769.719.719,0,0,0,.142.49c.266.266.945.036,1.259.247a1.336,1.336,0,0,1,.351.586.843.843,0,0,0,.357.484c.345.143.883-.329,1.257-.255s.68.716,1.065.716.7-.644,1.065-.716.913.4,1.257.255.4-.862.708-1.07.993.02,1.259-.247.036-.945.247-1.259.925-.358,1.07-.708-.329-.883-.255-1.258m-5.352,3.7a4.735,4.735,0,0,1-1.919-.4,4.793,4.793,0,0,1-2.331-2.206,4.762,4.762,0,0,1,.163-4.608A4.8,4.8,0,0,1,13.573,1.98a4.759,4.759,0,0,1,4.608-.163,4.794,4.794,0,0,1,2.206,2.331,4.767,4.767,0,0,1-4.363,6.687",
    transform: "translate(-9.623)",
    fill: "#ffaa01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11929",
    "data-name": "Tracciato 11929",
    d: "M69.869,55.556A4.352,4.352,0,1,1,65.517,51.2a4.352,4.352,0,0,1,4.352,4.352",
    transform: "translate(-59.116 -49.489)",
    fill: "#ffaa01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11930",
    "data-name": "Tracciato 11930",
    d: "M101.563,86.836a4.754,4.754,0,0,0-1.493-3.462,4.765,4.765,0,0,1-6.736,6.736,4.765,4.765,0,0,0,8.229-3.274",
    transform: "translate(-90.207 -80.581)",
    fill: "#fa9401"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11931",
    "data-name": "Tracciato 11931",
    d: "M61.351,55.78a4.352,4.352,0,0,1,7.6-2.894,4.352,4.352,0,1,0-6.688,5.563,4.333,4.333,0,0,1-.915-2.669",
    transform: "translate(-59.115 -49.488)",
    fill: "#fa9401"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11932",
    "data-name": "Tracciato 11932",
    d: "M121.177,114.808l-1.569-.279a.149.149,0,0,1-.108-.082l-.678-1.406a.149.149,0,0,0-.269,0l-.678,1.406a.149.149,0,0,1-.108.082l-1.569.279a.149.149,0,0,0-.072.259l1.175,1.03a.149.149,0,0,1,.048.141l-.279,1.442a.149.149,0,0,0,.216.161l1.332-.7a.149.149,0,0,1,.138,0l1.332.7a.149.149,0,0,0,.216-.161l-.279-1.442a.149.149,0,0,1,.048-.141l1.175-1.03a.149.149,0,0,0-.072-.259",
    transform: "translate(-112.186 -109.172)",
    fill: "#fa9401"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11933",
    "data-name": "Tracciato 11933",
    d: "M118.177,109.808l-1.569-.279a.149.149,0,0,1-.108-.082l-.678-1.406a.149.149,0,0,0-.269,0l-.678,1.406a.149.149,0,0,1-.108.082l-1.569.279a.149.149,0,0,0-.072.259l1.175,1.03a.149.149,0,0,1,.048.141l-.279,1.442a.149.149,0,0,0,.216.161l1.332-.7a.149.149,0,0,1,.138,0l1.332.7a.149.149,0,0,0,.216-.161l-.279-1.442a.149.149,0,0,1,.048-.141l1.175-1.03a.149.149,0,0,0-.072-.259",
    transform: "translate(-109.286 -104.339)",
    fill: "#f9d511"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5501",
    "data-name": "Raggruppa 5501",
    transform: "translate(0.334)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5500",
    "data-name": "Raggruppa 5500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5499",
    "data-name": "Raggruppa 5499",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11934",
    "data-name": "Tracciato 11934",
    d: "M18.81,1.189l-.628.628L11.774,8.225l-.628.628c-.284-.131-.632-.229-.729-.462-.143-.345.329-.883.255-1.258s-.716-.68-.716-1.065.644-.7.716-1.065a.452.452,0,0,0,.006-.128l1.258-1.258L14.832.722A.45.45,0,0,0,14.96.716C15.323.644,15.64,0,16.025,0s.7.644,1.065.716S18,.317,18.347.46c.233.1.331.445.463.729",
    transform: "translate(-9.957)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11935",
    "data-name": "Tracciato 11935",
    d: "M68.32,50.56l-7.8,7.8a1.336,1.336,0,0,0-.351-.586c-.314-.21-.993.02-1.259-.247a.719.719,0,0,1-.142-.49l.762-.762,6.709-6.71L67,48.807a.715.715,0,0,1,.49.142c.266.266.036.945.247,1.26a1.338,1.338,0,0,0,.586.351",
    transform: "translate(-57.129 -47.172)",
    fill: "#231f20"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeritocracy);
export default __webpack_public_path__ + "static/media/meritocracy.937330f9fb5e7844c1c66af1dc6a4cbe.svg";
export { ForwardRef as ReactComponent };